import { client } from "./client";
export async function login(email, password) {
    const res = await client.post("/api/v1/auth/login", { email, password });
    return res.data;
}
export async function refresh() {
    const res = await client.post("/api/v1/auth/refresh");
    return res.data;
}
export async function logout() {
    await client.post("/api/v1/auth/logout");
}
// V1.22: invite + password reset magic-link flow
export async function requestPasswordReset(email) {
    await client.post("/api/v1/auth/request-password-reset", { email });
}
export async function validateSetPasswordToken(token) {
    return (await client.get("/api/v1/auth/set-password/validate", { params: { token } })).data;
}
export async function setPasswordWithToken(token, new_password) {
    return (await client.post("/api/v1/auth/set-password", { token, new_password })).data;
}
